export default __webpack_public_path__ + "static/media/bg-12.46f15836.jpg";